import { render, staticRenderFns } from "./a-account-icon.vue?vue&type=template&id=3e597472&"
import script from "./a-account-icon.vue?vue&type=script&lang=js&"
export * from "./a-account-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports